import React, { createContext, useCallback, useContext, useState } from 'react';

export const tab = Object.freeze({
  MAIN_INFO: 'Main Information',
  ATTACHMENTS: 'Attachments',
  INTERNAL_COMMENTS: 'Staff Notes',
});

const InquiryModalContext = createContext({
  isInquiryModalOpen: false,
  openInquiryModal: () => {},
  closeInquiryModal: () => {},
  inquiryData: {},
  handleSetInquiryData: () => {},
  activeTab: tab.MAIN_INFO,
  setActiveTab: () => {},
  handleRefetchInquiries: () => {},
  isMessageModalOpen: false,
  setIsMessageModalOpen: () => {},
});

export const InquiryModalProvider = ({
  children,
  handleRefetchInquiries,
}) => {
  const [isInquiryModalOpen, setIsInquiryModalOpen] = useState(false);
  const [inquiryData, setInquiryData] = useState({});
  const [activeTab, setActiveTab] = useState(tab.MAIN_INFO);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);

  const openInquiryModal = useCallback((tabToOpen) => {
    setIsInquiryModalOpen(true);
    tabToOpen && setActiveTab(tabToOpen);
  }, []);

  const closeInquiryModal = useCallback(() => {
    setIsInquiryModalOpen(false);
    setInquiryData({});
    setActiveTab(tab.MAIN_INFO);
  }, []);

  const handleSetInquiryData = useCallback((data) => {
    const { date, time, ...rest } = data;
    setInquiryData({
      ...rest,
      dateTime: `${date} ${time}`,
    });
  }, []);

  return (
    <InquiryModalContext.Provider
      value={{
        isInquiryModalOpen,
        openInquiryModal,
        closeInquiryModal,
        inquiryData,
        handleSetInquiryData,
        activeTab,
        setActiveTab,
        handleRefetchInquiries,
        isMessageModalOpen,
        setIsMessageModalOpen,
      }}
    >
      {children}
    </InquiryModalContext.Provider>
  );
};

export const useInquiryModalContext = () => {
  return useContext(InquiryModalContext);
};
